import { getQueryStringValue } from './getQueryStringValue'

const queryParameterGclid = getQueryStringValue('gclid')
const gclsrcParam = getQueryStringValue('gclsrc')
const isGclsrcValid = !gclsrcParam || gclsrcParam.indexOf('aw') !== -1

if (queryParameterGclid && isGclsrcValid) {
    createExpiryRecord(queryParameterGclid)
}

function createExpiryRecord(value) {
    const expiryPeriod = 90 * 24 * 60 * 60 * 1000 // 90 day expiry in milliseconds

    const expiryDate = new Date().getTime() + expiryPeriod
    const gclidRecord = {
        value: value,
        expiryDate: expiryDate,
    }

    localStorage.setItem('gclid', JSON.stringify(gclidRecord))
}

function getGclidRecord() {
    const gclidRecord = JSON.parse(localStorage.getItem('gclid'))
    return gclidRecord || undefined
}

export function hasValidGclid() {
    const gclidRecord = getGclidRecord()
    const isGclidValid = gclidRecord && new Date().getTime() < gclidRecord.expiryDate
    return isGclidValid
}

/**
 * Returns the google client id (used for ads)
 */
export function getGclid() {
    return hasValidGclid() ? getGclidRecord().value : undefined
}
